export const product_order_item_statuses =  [
  {id:0, name: 'Pending', color: '', is_visible: false, before_status: []},
  {id:1, name: 'In-Manufacturing', color: '#f8961e', is_visible: false, before_status: []},
  {id:2, name: 'In-QC', color: '#f8961e', is_visible: false, before_status: []},
  {id:3, name: 'In-Dispatch', color: '#f9c74f', is_visible: false, before_status: []},
  {id:4, name: 'Dispatched', color: '#006d77', is_visible: false, before_status: []},
  {id:5, name: 'Customer-Received', color: '#006d77', is_visible: false, before_status: []},
  {id:6, name: 'Returned', color: '#f72585', is_visible: true, before_status: ['Customer-Received']},
  {id:7, name: 'Goods-Lost', color: '#f72585', is_visible: false, before_status: []},
  {id:8, name: 'Cancelled', color: '#d62828', is_visible: false, before_status: ['Submitted', 'Pending', '']},
];


export const product_order_statuses =  [
  {id: 1, name: 'Submitted', slug: 'submitted', color: '#f8961e',
    before_status: [], is_visible: false
  },
  {id: 2, name: 'Pending', slug: 'pending', color: '#f9844a',
    before_status: ['Submitted'], is_visible: false
  },
  {id: 3, name: 'In-Manufacturing', slug: 'in_manufacturing', color: '#f9c74f',
    before_status: ['Pending'], is_visible: false
  },
  {id: 4, name: 'In-QC', slug: 'in_qc', color: '#006d77',
    before_status: ['In-Manufacturing'], is_visible: false
  },
  {id: 5, name: 'In-Dispatch', slug: 'in_dispatch', color: '#219ebc',
    before_status: ['In-QC'], is_visible: false
  },
  {id: 6, name: 'Dispatched', slug: 'dispatched', color: '#006d77',
    before_status: ['In-Dispatch'], is_visible: false
  },
  {id: 7, name: 'Customer-Received', slug: 'customer_received', color: '#d62828',
    before_status: ['Dispatched'], is_visible: false
  },
  {id: 8, name: 'Returned', slug: 'returned', color: '#3a0ca3',
    before_status: ['Customer-Received'], is_visible: true
  },
  {id: 9, name: 'Goods-Lost', slug: 'goods_lost', color: '#f72585',
    before_status: ['In-Dispatch'], is_visible: false
  },
  {id: 10, name: 'Cancelled', slug: 'cancel', color: '#d62828',
    before_status: ['Submitted', 'Pending'], is_visible: true
  },
]
